export enum UserProperties {
  default_page = 'default_page',
  prefer_language = 'prefer_language',
}
